export const SESSION_TRANSITION_REQUEST_EVENT = "qit-session-transition-request";

export interface SessionTransitionRequestDetail {
    reason: "mix_interrupted_by_vote";
    fromSongId?: string;
    toSongId?: string;
}
